import classNames from 'classnames';

interface NotificationPanelFilterButtonProps {
  title: string;
  additionClasses?: string;
  onClick?: () => void;
}

export function NotificationPanelFilterButton(props: NotificationPanelFilterButtonProps) {
  const { title, additionClasses, onClick } = props;
  return (
    <button onClick={onClick} className={classNames('text-cyan-900 leading-4 text-[13px] font-bold', additionClasses)}>
      {title}
    </button>
  );
}
